export default __webpack_public_path__ + "static/media/security.4842ed85.svg";